export const latestLondon = [
  {
    LL_ID: "99a912d1-cca8-4250-ad0d-15cebdfd0181",
    ll_name: "Myrooms",
    RU_ID: "132,392",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,000",
    "Price vs Market": "-210",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132392",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "318,630",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,000",
    "Price vs Market": "0",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/318630",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "137,648",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,004",
    "Price vs Market": "174",
    Available_From: "Mar 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/137648",
  },
  {
    LL_ID: "358d2c8c-a4c9-42b1-b59b-503744f05286",
    ll_name: "Vasanth Andrews",
    RU_ID: "165,944",
    Verified: "yes",
    City: "london",
    Neigbourhood: "southwark",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,005",
    "Price vs Market": "-295",
    Available_From: "Feb 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/165944",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "475,270",
    Verified: "no",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "1,020",
    "Price vs Market": "370",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/475270",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "137,709",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,030",
    "Price vs Market": "80",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/137709",
  },
  {
    LL_ID: "2d391945-afce-4510-a1e1-3824bd3e5b86",
    ll_name: "Ash Velmi",
    RU_ID: "290,278",
    Verified: "yes",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,050",
    "Price vs Market": "0",
    Available_From: "Apr 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/290278",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,958",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,075",
    "Price vs Market": "-555",
    Available_From: "Apr 24, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506958",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "117,940",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,095",
    "Price vs Market": "-105",
    Available_From: "Apr 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/117940",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "117,375",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,095",
    "Price vs Market": "-105",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/117375",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "610,076",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,096",
    "Price vs Market": "-104",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/610076",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "610,072",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,096",
    "Price vs Market": "-104",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/610072",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "306,174",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "1,100",
    "Price vs Market": "-530",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/306174",
  },
  {
    LL_ID: "beee956f-d80f-48a2-8445-bfe760a8122e",
    ll_name: "Accommodation London",
    RU_ID: "523,306",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,100",
    "Price vs Market": "-110",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/523306",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "134,455",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,100",
    "Price vs Market": "100",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/134455",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,916",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "1,100",
    "Price vs Market": "200",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506916",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "308,451",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "1,127",
    "Price vs Market": "347",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/308451",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,915",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "1,150",
    "Price vs Market": "250",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506915",
  },
  {
    LL_ID: "beee956f-d80f-48a2-8445-bfe760a8122e",
    ll_name: "Accommodation London",
    RU_ID: "349,524",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,180",
    "Price vs Market": "-30",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/349524",
  },
  {
    LL_ID: "99a912d1-cca8-4250-ad0d-15cebdfd0181",
    ll_name: "Myrooms",
    RU_ID: "132,363",
    Verified: "yes",
    City: "london",
    Neigbourhood: "southwark",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,189",
    "Price vs Market": "-91",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132363",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "517,701",
    Verified: "no",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,200",
    "Price vs Market": "90",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/517701",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "517,702",
    Verified: "no",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,200",
    "Price vs Market": "90",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/517702",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "153,544",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "1,200",
    "Price vs Market": "120",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/153544",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "271,060",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,220",
    "Price vs Market": "140",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/271060",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,275",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592275",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,274",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592274",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,261",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592261",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,272",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592272",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,270",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592270",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,263",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592263",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,271",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592271",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,269",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592269",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,273",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592273",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,268",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592268",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,267",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592267",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,266",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592266",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,265",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592265",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,264",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592264",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,262",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,264",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592262",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "343,891",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "1,270",
    "Price vs Market": "370",
    Available_From: "Apr 4, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/343891",
  },
  {
    LL_ID: "99a912d1-cca8-4250-ad0d-15cebdfd0181",
    ll_name: "Myrooms",
    RU_ID: "137,031",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,296",
    "Price vs Market": "86",
    Available_From: "Apr 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/137031",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,995",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,307",
    "Price vs Market": "-453",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600995",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,994",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,307",
    "Price vs Market": "-453",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600994",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,996",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,307",
    "Price vs Market": "-453",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600996",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,998",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,307",
    "Price vs Market": "-453",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600998",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,993",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,307",
    "Price vs Market": "-453",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600993",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,997",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,307",
    "Price vs Market": "-453",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600997",
  },
  {
    LL_ID: "99a912d1-cca8-4250-ad0d-15cebdfd0181",
    ll_name: "Myrooms",
    RU_ID: "132,394",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "1,310",
    "Price vs Market": "100",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132394",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,011",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,342",
    "Price vs Market": "-418",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601011",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,013",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,342",
    "Price vs Market": "-418",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601013",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,010",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,342",
    "Price vs Market": "-418",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601010",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,009",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,342",
    "Price vs Market": "-418",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601009",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,014",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,342",
    "Price vs Market": "-418",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601014",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,012",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,342",
    "Price vs Market": "-418",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601012",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,030",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,377",
    "Price vs Market": "-383",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601030",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,025",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,377",
    "Price vs Market": "-383",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601025",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,026",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,377",
    "Price vs Market": "-383",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601026",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,027",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,377",
    "Price vs Market": "-383",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601027",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,029",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,377",
    "Price vs Market": "-383",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601029",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,028",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,377",
    "Price vs Market": "-383",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601028",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,003",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,438",
    "Price vs Market": "-322",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601003",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,002",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,438",
    "Price vs Market": "-322",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601002",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,000",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,438",
    "Price vs Market": "-322",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601000",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,001",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,438",
    "Price vs Market": "-322",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601001",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,999",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,438",
    "Price vs Market": "-322",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600999",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,005",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,438",
    "Price vs Market": "-322",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601005",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,004",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,438",
    "Price vs Market": "-322",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601004",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,061",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601061",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,043",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601043",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,040",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601040",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,041",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601041",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,042",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601042",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,044",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601044",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,045",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601045",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,046",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601046",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,057",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601057",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,058",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601058",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,059",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601059",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,060",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601060",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,062",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,441",
    "Price vs Market": "-319",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601062",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,050",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601050",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,048",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601048",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,047",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601047",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,052",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601052",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,054",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601054",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,051",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601051",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,049",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601049",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,053",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,442",
    "Price vs Market": "-318",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601053",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,742",
    Verified: "yes",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,452",
    "Price vs Market": "342",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609742",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,277",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592277",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,284",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592284",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,285",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592285",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,282",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592282",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,279",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592279",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,278",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592278",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,280",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592280",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,281",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592281",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,283",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592283",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,276",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,470",
    "Price vs Market": "",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592276",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,017",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,472",
    "Price vs Market": "-288",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601017",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,021",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,472",
    "Price vs Market": "-288",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601021",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,022",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,472",
    "Price vs Market": "-288",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601022",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,015",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,472",
    "Price vs Market": "-288",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601015",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,020",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,472",
    "Price vs Market": "-288",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601020",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,018",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,472",
    "Price vs Market": "-288",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601018",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,016",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,472",
    "Price vs Market": "-288",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601016",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,078",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601078",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,084",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601084",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,083",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601083",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,085",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601085",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,086",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601086",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,082",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601082",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,077",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601077",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,079",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601079",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,076",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601076",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,075",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601075",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,081",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601081",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,074",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601074",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,073",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601073",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,080",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,485",
    "Price vs Market": "-275",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601080",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,802",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322802",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,801",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322801",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,800",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322800",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,799",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322799",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,757",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322757",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,798",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322798",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,797",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322797",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,796",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322796",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,795",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322795",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,794",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322794",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,793",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322793",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,792",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322792",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,791",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322791",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,790",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322790",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,789",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322789",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,788",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322788",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,787",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322787",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,786",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322786",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,785",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322785",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,784",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322784",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,783",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322783",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,782",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322782",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,781",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322781",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,780",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322780",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,779",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322779",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,778",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322778",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,777",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322777",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,776",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322776",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,775",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322775",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,774",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322774",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,773",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322773",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,772",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322772",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,771",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322771",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,770",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322770",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,769",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322769",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,768",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322768",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,767",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322767",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,766",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322766",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,765",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322765",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,764",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322764",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,763",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322763",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,762",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322762",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,760",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322760",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,759",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322759",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,758",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322758",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,761",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "residence",
    Rooms: 1,
    Price: "1,493",
    "Price vs Market": "",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322761",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,036",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601036",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,038",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601038",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,035",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601035",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,034",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601034",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,033",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601033",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,032",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601032",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,031",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601031",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,037",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,507",
    "Price vs Market": "-253",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601037",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "639,950",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,521",
    "Price vs Market": "-239",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639950",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "639,951",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,521",
    "Price vs Market": "-239",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639951",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "639,948",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,521",
    "Price vs Market": "-239",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639948",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "639,947",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,521",
    "Price vs Market": "-239",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639947",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "639,949",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,521",
    "Price vs Market": "-239",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639949",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "438,864",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,550",
    "Price vs Market": "-200",
    Available_From: "Apr 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/438864",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "415,019",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,550",
    "Price vs Market": "-200",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/415019",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "600,992",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,551",
    "Price vs Market": "-209",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/600992",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,063",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601063",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,069",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601069",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,068",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601068",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,067",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601067",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,064",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601064",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,065",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601065",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,070",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601070",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,066",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,572",
    "Price vs Market": "-188",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601066",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,008",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "-174",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601008",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,312",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322312",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,307",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322307",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,305",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322305",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,308",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322308",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,309",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322309",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,310",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322310",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,303",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322303",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,304",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322304",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,306",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322306",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,311",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,586",
    "Price vs Market": "16",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322311",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "595,739",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,600",
    "Price vs Market": "-150",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/595739",
  },
  {
    LL_ID: "afede053-f9b1-4e62-8513-df074f68048d",
    ll_name: "Maycourt Properties Ltd",
    RU_ID: "297,720",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,600",
    "Price vs Market": "0",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/297720",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,329",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322329",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,317",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322317",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,316",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322316",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,333",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322333",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,332",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322332",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,331",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322331",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,330",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322330",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,328",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322328",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,326",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322326",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,325",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322325",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,324",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322324",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,323",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322323",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,322",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322322",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,321",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322321",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,314",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322314",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,320",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322320",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,319",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322319",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,318",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322318",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,315",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322315",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,327",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,633",
    "Price vs Market": "63",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322327",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,024",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,638",
    "Price vs Market": "-122",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601024",
  },
  {
    LL_ID: "591a6156-8b73-471b-b16c-bc8ee04bb4fd",
    ll_name: "Marcin Klos",
    RU_ID: "571,669",
    Verified: "no",
    City: "london",
    Neigbourhood: "ealing",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,650",
    "Price vs Market": "-50",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/571669",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,056",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,685",
    "Price vs Market": "-75",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601056",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "352,507",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,750",
    "Price vs Market": "-350",
    Available_From: "Feb 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/352507",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,756",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322756",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,747",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322747",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,751",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322751",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,745",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322745",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,746",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322746",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,744",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322744",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,752",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322752",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,754",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322754",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,750",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322750",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,753",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322753",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,755",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322755",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,749",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322749",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,748",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,791",
    "Price vs Market": "-319",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322748",
  },
  {
    LL_ID: "bb837cf3-2697-4d27-8e92-7ab7035e7c8c",
    ll_name: "endri hoxha",
    RU_ID: "602,233",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,850",
    "Price vs Market": "100",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602233",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,379",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,906",
    "Price vs Market": "-154",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592379",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,378",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,906",
    "Price vs Market": "-154",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592378",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,381",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,906",
    "Price vs Market": "-154",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592381",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,380",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,906",
    "Price vs Market": "-154",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592380",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,742",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,975",
    "Price vs Market": "-135",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322742",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,741",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,975",
    "Price vs Market": "-135",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322741",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,738",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,975",
    "Price vs Market": "-135",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322738",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,740",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,975",
    "Price vs Market": "-135",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322740",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,739",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,975",
    "Price vs Market": "-135",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322739",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,737",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,975",
    "Price vs Market": "-135",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322737",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "322,743",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,975",
    "Price vs Market": "-135",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/322743",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,382",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,998",
    "Price vs Market": "-62",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592382",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,383",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,998",
    "Price vs Market": "-62",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592383",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,384",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,998",
    "Price vs Market": "-62",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592384",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,385",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,998",
    "Price vs Market": "-62",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592385",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,386",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,998",
    "Price vs Market": "-62",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592386",
  },
  {
    LL_ID: "c7c15b20-ef48-4f52-bc57-78bbc03ccef7",
    ll_name: "London Nest",
    RU_ID: "592,387",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "1,998",
    "Price vs Market": "-62",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/592387",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "353,815",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "10,439.08",
    "Price vs Market": "3,879.08",
    Available_From: "Mar 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/353815",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,449",
    Verified: "no",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "11,228",
    "Price vs Market": "3,798",
    Available_From: "Mar 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623449",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "576,603",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 6,
    Price: "11,347.42",
    "Price vs Market": "4,777.42",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/576603",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "358,125",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 5,
    Price: "11,471.92",
    "Price vs Market": "4,901.92",
    Available_From: "Feb 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/358125",
  },
  {
    LL_ID: "045f909a-98f1-4b94-8f5f-16c5160238b8",
    ll_name: "Bloomsbury Estates",
    RU_ID: "411,138",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "11,958",
    "Price vs Market": "6,408",
    Available_From: "Feb 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/411138",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "601,917",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "12,076.92",
    "Price vs Market": "8,596.92",
    Available_From: "Feb 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601917",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,364",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "12,803.25",
    "Price vs Market": "6,323.25",
    Available_From: "Mar 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460364",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "358,103",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "13,028.17",
    "Price vs Market": "6,458.17",
    Available_From: "Feb 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/358103",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "353,788",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "13,563.25",
    "Price vs Market": "6,993.25",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/353788",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,407",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "14,066.83",
    "Price vs Market": "10,066.83",
    Available_From: "Mar 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623407",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "518,043",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "16,468.67",
    "Price vs Market": "10,118.67",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/518043",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,394",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "17,566.58",
    "Price vs Market": "11,006.58",
    Available_From: "Feb 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460394",
  },
  {
    LL_ID: "7a4f443c-ba57-402c-9ecf-c8eee71ce2cf",
    ll_name: "dustin gore",
    RU_ID: "289,631",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,000",
    "Price vs Market": "390",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/289631",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "399,035",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,096",
    "Price vs Market": "-964",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/399035",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "399,036",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,096",
    "Price vs Market": "-964",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/399036",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "399,039",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,096",
    "Price vs Market": "-964",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/399039",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "472,167",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,195",
    "Price vs Market": "435",
    Available_From: "Mar 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/472167",
  },
  {
    LL_ID: "1a38549e-8e7f-4273-9a4c-95b5a586b106",
    ll_name: "The Stay Club",
    RU_ID: "601,072",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,223",
    "Price vs Market": "463",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601072",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,674",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,294",
    "Price vs Market": "-766",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398674",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,678",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,294",
    "Price vs Market": "-766",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398678",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,104",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,294",
    "Price vs Market": "-766",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398104",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,100",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,294",
    "Price vs Market": "-766",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398100",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,669",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,294",
    "Price vs Market": "-766",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398669",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,670",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,294",
    "Price vs Market": "-766",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398670",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,673",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,294",
    "Price vs Market": "-766",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398673",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,106",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,294",
    "Price vs Market": "-506",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398106",
  },
  {
    LL_ID: "1f12b5c2-b06a-42c0-b925-0458f227a6e8",
    ll_name: "LondonFineStay",
    RU_ID: "418,994",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,362.5",
    "Price vs Market": "",
    Available_From: "Feb 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/418994",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "448,897",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,420",
    "Price vs Market": "220",
    Available_From: "Apr 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448897",
  },
  {
    LL_ID: "e68e2ee2-784f-4ec6-b788-ef5dacc90eb8",
    ll_name: "City Living London",
    RU_ID: "428,392",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,450",
    "Price vs Market": "-1,150",
    Available_From: "Mar 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/428392",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "398,672",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,488",
    "Price vs Market": "-572",
    Available_From: "Feb 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/398672",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "468,979",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,488",
    "Price vs Market": "-572",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/468979",
  },
  {
    LL_ID: "045f909a-98f1-4b94-8f5f-16c5160238b8",
    ll_name: "Bloomsbury Estates",
    RU_ID: "460,504",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,500",
    "Price vs Market": "-430",
    Available_From: "Apr 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460504",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,271",
    Verified: "no",
    City: "london",
    Neigbourhood: "OTHER_london",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,500",
    "Price vs Market": "",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602271",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "294,848",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,505",
    "Price vs Market": "-295",
    Available_From: "Mar 29, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/294848",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,434",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,548.33",
    "Price vs Market": "",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623434",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "605,395",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,574",
    "Price vs Market": "-486",
    Available_From: "Apr 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605395",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "605,392",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,574",
    "Price vs Market": "-486",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605392",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "639,554",
    Verified: "no",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,655.67",
    "Price vs Market": "335.67",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639554",
  },
  {
    LL_ID: "c30f4266-df0c-409d-b5eb-bac4817aab96",
    ll_name: "Nestor Group  Ltd.",
    RU_ID: "468,977",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,683",
    "Price vs Market": "-117",
    Available_From: "Mar 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/468977",
  },
  {
    LL_ID: "e68e2ee2-784f-4ec6-b788-ef5dacc90eb8",
    ll_name: "City Living London",
    RU_ID: "428,616",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,700",
    "Price vs Market": "-900",
    Available_From: "Feb 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/428616",
  },
  {
    LL_ID: "e68e2ee2-784f-4ec6-b788-ef5dacc90eb8",
    ll_name: "City Living London",
    RU_ID: "428,623",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,700",
    "Price vs Market": "-900",
    Available_From: "Mar 24, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/428623",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,410",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,722",
    "Price vs Market": "-48",
    Available_From: "Feb 14, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623410",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,442",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "2,722",
    "Price vs Market": "",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623442",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "438,295",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/438295",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "420,076",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Mar 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/420076",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "420,202",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Mar 29, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/420202",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "476,676",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/476676",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "420,090",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Apr 22, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/420090",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "420,197",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Feb 23, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/420197",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "420,092",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/420092",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "476,678",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,741.67",
    "Price vs Market": "-58.33",
    Available_From: "Mar 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/476678",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "420,083",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,741.67",
    "Price vs Market": "871.67",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/420083",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "438,451",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "2,750",
    "Price vs Market": "-2,090",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/438451",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "420,065",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "2,750",
    "Price vs Market": "-2,090",
    Available_From: "Apr 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/420065",
  },
  {
    LL_ID: "fec651ac-ccfa-49c9-aa79-dd90649d2353",
    ll_name: "Andrew Herring",
    RU_ID: "223,573",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,750",
    "Price vs Market": "-150",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/223573",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,257",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,750",
    "Price vs Market": "1,650",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602257",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,268",
    Verified: "no",
    City: "london",
    Neigbourhood: "OTHER_london",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,750",
    "Price vs Market": "",
    Available_From: "Mar 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602268",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,276",
    Verified: "no",
    City: "london",
    Neigbourhood: "OTHER_london",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,750",
    "Price vs Market": "",
    Available_From: "Feb 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602276",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,277",
    Verified: "no",
    City: "london",
    Neigbourhood: "OTHER_london",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,750",
    "Price vs Market": "",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602277",
  },
  {
    LL_ID: "1f12b5c2-b06a-42c0-b925-0458f227a6e8",
    ll_name: "LondonFineStay",
    RU_ID: "418,990",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,783.33",
    "Price vs Market": "",
    Available_From: "Feb 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/418990",
  },
  {
    LL_ID: "e2329d5c-3161-4da6-a7e3-b54609c36b5d",
    ll_name: "ALTIDO London ltd",
    RU_ID: "472,970",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,800",
    "Price vs Market": "-100",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/472970",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,259",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,805",
    "Price vs Market": "495",
    Available_From: "Feb 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602259",
  },
  {
    LL_ID: "1f12b5c2-b06a-42c0-b925-0458f227a6e8",
    ll_name: "LondonFineStay",
    RU_ID: "418,992",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,807.58",
    "Price vs Market": "",
    Available_From: "Feb 22, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/418992",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "605,391",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,834",
    "Price vs Market": "-226",
    Available_From: "Mar 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605391",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "605,379",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "2,834",
    "Price vs Market": "-226",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605379",
  },
  {
    LL_ID: "e68e2ee2-784f-4ec6-b788-ef5dacc90eb8",
    ll_name: "City Living London",
    RU_ID: "428,386",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,850",
    "Price vs Market": "-1,330",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/428386",
  },
  {
    LL_ID: "14108dc7-496d-4f67-9259-6ec38a506d28",
    ll_name: "Ideal Move",
    RU_ID: "641,593",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "2,950",
    "Price vs Market": "640",
    Available_From: "Feb 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/641593",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "641,324",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,000",
    "Price vs Market": "-480",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/641324",
  },
  {
    LL_ID: "e68e2ee2-784f-4ec6-b788-ef5dacc90eb8",
    ll_name: "City Living London",
    RU_ID: "428,165",
    Verified: "no",
    City: "london",
    Neigbourhood: "city of london",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,000",
    "Price vs Market": "-460",
    Available_From: "Mar 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/428165",
  },
  {
    LL_ID: "4eeaba76-338f-4fe8-ba61-bec0514f7a95",
    ll_name: "Auris Property Advisers",
    RU_ID: "375,568",
    Verified: "no",
    City: "london",
    Neigbourhood: "richmond upon thames",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,000",
    "Price vs Market": "1,370",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/375568",
  },
  {
    LL_ID: "831383f9-f15d-421f-b404-c45372fd0707",
    ll_name: "Let Club ltd",
    RU_ID: "266,723",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,029.17",
    "Price vs Market": "-1,810.83",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/266723",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "603,980",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,094",
    "Price vs Market": "34",
    Available_From: "Mar 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603980",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "314,251",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,100",
    "Price vs Market": "1,500",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/314251",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "314,600",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,241",
    "Price vs Market": "-1,599",
    Available_From: "May 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/314600",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "342,393",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,241",
    "Price vs Market": "1",
    Available_From: "Mar 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/342393",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "311,707",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,288",
    "Price vs Market": "-1,552",
    Available_From: "Apr 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/311707",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "301,201",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,288",
    "Price vs Market": "-1,552",
    Available_From: "Apr 28, 2022",
    "Admin Fee Type": "fixed",
    Admin_Fee_Value: "80",
    Link: "http://www.spotahome.com/london/for-rent:apartments/301201",
  },
  {
    LL_ID: "e2329d5c-3161-4da6-a7e3-b54609c36b5d",
    ll_name: "ALTIDO London ltd",
    RU_ID: "312,629",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,294.08",
    "Price vs Market": "494.08",
    Available_From: "Mar 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/312629",
  },
  {
    LL_ID: "e68e2ee2-784f-4ec6-b788-ef5dacc90eb8",
    ll_name: "City Living London",
    RU_ID: "428,159",
    Verified: "no",
    City: "london",
    Neigbourhood: "city of london",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,300",
    "Price vs Market": "-160",
    Available_From: "Mar 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/428159",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "603,986",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,354",
    "Price vs Market": "294",
    Available_From: "Mar 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603986",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "603,972",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,354",
    "Price vs Market": "294",
    Available_From: "Apr 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603972",
  },
  {
    LL_ID: "a8b0bb73-d2c4-4b0f-a7ee-813eb4a3e799",
    ll_name: "Flavio Rampa",
    RU_ID: "605,255",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,500",
    "Price vs Market": "740",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605255",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "506,034",
    Verified: "no",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,600",
    "Price vs Market": "-720",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506034",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "637,570",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,600",
    "Price vs Market": "-200",
    Available_From: "Mar 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/637570",
  },
  {
    LL_ID: "a8b0bb73-d2c4-4b0f-a7ee-813eb4a3e799",
    ll_name: "Flavio Rampa",
    RU_ID: "574,207",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,600",
    "Price vs Market": "380",
    Available_From: "Mar 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/574207",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "603,973",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,614",
    "Price vs Market": "554",
    Available_From: "May 4, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603973",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "228,460",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,711",
    "Price vs Market": "1,331",
    Available_From: "Apr 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/228460",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "610,763",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,734",
    "Price vs Market": "834",
    Available_From: "Apr 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/610763",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "227,994",
    Verified: "no",
    City: "london",
    Neigbourhood: "southwark",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "3,818",
    "Price vs Market": "1,518",
    Available_From: "Feb 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/227994",
  },
  {
    LL_ID: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    RU_ID: "294,182",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,822.83",
    "Price vs Market": "672.83",
    Available_From: "Mar 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/294182",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "641,719",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "3,874",
    "Price vs Market": "1,144",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/641719",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "603,699",
    Verified: "no",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,950.42",
    "Price vs Market": "",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603699",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "314,258",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "3,992",
    "Price vs Market": "-848",
    Available_From: "Apr 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/314258",
  },
  {
    LL_ID: "6480425d-ce26-4e31-8554-f40f99672851",
    ll_name: "Dreams Unlimited",
    RU_ID: "392,923",
    Verified: "no",
    City: "london",
    Neigbourhood: "OTHER_london",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "4,000",
    "Price vs Market": "",
    Available_From: "Mar 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/392923",
  },
  {
    LL_ID: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    RU_ID: "314,586",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,040",
    "Price vs Market": "-800",
    Available_From: "Apr 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/314586",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "467,406",
    Verified: "no",
    City: "london",
    Neigbourhood: "hounslow",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "4,050",
    "Price vs Market": "",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/467406",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,180",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,100",
    "Price vs Market": "580",
    Available_From: "Feb 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448180",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "603,975",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "4,134",
    "Price vs Market": "1,074",
    Available_From: "Feb 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603975",
  },
  {
    LL_ID: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    RU_ID: "390,894",
    Verified: "no",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,192.83",
    "Price vs Market": "32.83",
    Available_From: "Apr 29, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/390894",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "604,187",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,334.42",
    "Price vs Market": "1,824.42",
    Available_From: "Feb 24, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/604187",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "597,689",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,350",
    "Price vs Market": "110",
    Available_From: "Feb 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/597689",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "427,010",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,350",
    "Price vs Market": "2,480",
    Available_From: "Feb 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/427010",
  },
  {
    LL_ID: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    RU_ID: "225,996",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,415",
    "Price vs Market": "-425",
    Available_From: "Apr 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/225996",
  },
  {
    LL_ID: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    RU_ID: "511,630",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,455.5",
    "Price vs Market": "-384.5",
    Available_From: "Apr 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/511630",
  },
  {
    LL_ID: "831383f9-f15d-421f-b404-c45372fd0707",
    ll_name: "Let Club ltd",
    RU_ID: "297,811",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,500",
    "Price vs Market": "-340",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/297811",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "639,571",
    Verified: "no",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "4,534.33",
    "Price vs Market": "",
    Available_From: "Mar 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639571",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "467,444",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,550",
    "Price vs Market": "990",
    Available_From: "Mar 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/467444",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "598,060",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,550",
    "Price vs Market": "990",
    Available_From: "Mar 22, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/598060",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "598,053",
    Verified: "no",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,550",
    "Price vs Market": "1,050",
    Available_From: "Mar 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/598053",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "430,519",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,550",
    "Price vs Market": "2,710",
    Available_From: "Feb 23, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/430519",
  },
  {
    LL_ID: "c11842e9-5e22-42f9-8c97-f593b1a4e4fd",
    ll_name: "Hampstead Apartments",
    RU_ID: "603,976",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,654",
    "Price vs Market": "1,854",
    Available_From: "Feb 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603976",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "467,435",
    Verified: "no",
    City: "london",
    Neigbourhood: "city of london",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,725",
    "Price vs Market": "1,155",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/467435",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "467,433",
    Verified: "no",
    City: "london",
    Neigbourhood: "city of london",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,725",
    "Price vs Market": "1,335",
    Available_From: "Mar 18, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/467433",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "430,521",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,725",
    "Price vs Market": "1,515",
    Available_From: "Apr 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/430521",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "467,442",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,750",
    "Price vs Market": "1,150",
    Available_From: "Apr 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/467442",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "425,268",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "4,757",
    "Price vs Market": "-1,813",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/425268",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,231",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,800",
    "Price vs Market": "1,280",
    Available_From: "Feb 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448231",
  },
  {
    LL_ID: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    RU_ID: "391,146",
    Verified: "no",
    City: "london",
    Neigbourhood: "southwark",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "4,809.42",
    "Price vs Market": "",
    Available_From: "Feb 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/391146",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "515,971",
    Verified: "no",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,830.83",
    "Price vs Market": "1,570.83",
    Available_From: "Feb 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/515971",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,436",
    Verified: "no",
    City: "london",
    Neigbourhood: "barnet",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,847.33",
    "Price vs Market": "",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623436",
  },
  {
    LL_ID: "9e9838cf-faa1-4ecc-8d0a-dc76053342f0",
    ll_name: "PickThePlace",
    RU_ID: "431,299",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,900",
    "Price vs Market": "790",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/431299",
  },
  {
    LL_ID: "9e9838cf-faa1-4ecc-8d0a-dc76053342f0",
    ll_name: "PickThePlace",
    RU_ID: "431,449",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "4,900",
    "Price vs Market": "790",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/431449",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,446",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,906",
    "Price vs Market": "1,616",
    Available_From: "Feb 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623446",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "605,948",
    Verified: "no",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "4,940.58",
    "Price vs Market": "940.58",
    Available_From: "Feb 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605948",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,445",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "4,950",
    "Price vs Market": "450",
    Available_From: "Feb 24, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602445",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,296",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "5,000",
    "Price vs Market": "1,440",
    Available_From: "Mar 14, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448296",
  },
  {
    LL_ID: "a8b0bb73-d2c4-4b0f-a7ee-813eb4a3e799",
    ll_name: "Flavio Rampa",
    RU_ID: "639,733",
    Verified: "no",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,116",
    "Price vs Market": "906",
    Available_From: "Apr 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639733",
  },
  {
    LL_ID: "a8b0bb73-d2c4-4b0f-a7ee-813eb4a3e799",
    ll_name: "Flavio Rampa",
    RU_ID: "639,742",
    Verified: "no",
    City: "london",
    Neigbourhood: "southwark",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,116",
    "Price vs Market": "1,806",
    Available_From: "Apr 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639742",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "425,254",
    Verified: "no",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,308.33",
    "Price vs Market": "",
    Available_From: "Feb 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/425254",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "597,560",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,400",
    "Price vs Market": "2,080",
    Available_From: "Feb 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/597560",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,431",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,535.17",
    "Price vs Market": "1,415.17",
    Available_From: "Feb 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623431",
  },
  {
    LL_ID: "509efdc7-a806-49ca-99c9-29f805135dda",
    ll_name: "Home To Host",
    RU_ID: "602,449",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 5,
    Price: "5,610",
    "Price vs Market": "1,170",
    Available_From: "Apr 23, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/602449",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "601,920",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "5,642.08",
    "Price vs Market": "2,662.08",
    Available_From: "Mar 22, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601920",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "570,300",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,750",
    "Price vs Market": "2,680",
    Available_From: "Feb 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/570300",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,412",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,764.08",
    "Price vs Market": "924.08",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623412",
  },
  {
    LL_ID: "d6500e09-ac77-4b5b-8bd4-cef1dcdba073",
    ll_name: "PVL Properties Limited",
    RU_ID: "456,771",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "5,800",
    "Price vs Market": "-620",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/456771",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,260",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "5,800",
    "Price vs Market": "3,000",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448260",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "639,577",
    Verified: "no",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,855.5",
    "Price vs Market": "2,775.5",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639577",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,406",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "5,928.58",
    "Price vs Market": "1,088.58",
    Available_From: "Feb 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460406",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "506,989",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "5,937.33",
    "Price vs Market": "2,737.33",
    Available_From: "Apr 4, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506989",
  },
  {
    LL_ID: "14108dc7-496d-4f67-9259-6ec38a506d28",
    ll_name: "Ideal Move",
    RU_ID: "131,942",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "550",
    "Price vs Market": "-50",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/131942",
  },
  {
    LL_ID: "14108dc7-496d-4f67-9259-6ec38a506d28",
    ll_name: "Ideal Move",
    RU_ID: "162,256",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "550",
    "Price vs Market": "-50",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/162256",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,968",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "580",
    "Price vs Market": "-170",
    Available_From: "Mar 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609968",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,978",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "585",
    "Price vs Market": "-125",
    Available_From: "Mar 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609978",
  },
  {
    LL_ID: "045f909a-98f1-4b94-8f5f-16c5160238b8",
    ll_name: "Bloomsbury Estates",
    RU_ID: "460,500",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "6,000",
    "Price vs Market": "-420",
    Available_From: "Apr 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460500",
  },
  {
    LL_ID: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    RU_ID: "598,057",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "6,075",
    "Price vs Market": "3,475",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/598057",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "639,532",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "6,180.17",
    "Price vs Market": "3,580.17",
    Available_From: "Feb 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639532",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,248",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "6,351.17",
    "Price vs Market": "1,851.17",
    Available_From: "Feb 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460248",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,354",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "6,351.17",
    "Price vs Market": "1,851.17",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460354",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,352",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "6,351.17",
    "Price vs Market": "1,851.17",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460352",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "354,027",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "6,351.17",
    "Price vs Market": "2,831.17",
    Available_From: "Feb 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/354027",
  },
  {
    LL_ID: "9e9838cf-faa1-4ecc-8d0a-dc76053342f0",
    ll_name: "PickThePlace",
    RU_ID: "431,296",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "6,500",
    "Price vs Market": "2,500",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/431296",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,403",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "6,587.5",
    "Price vs Market": "3,027.5",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460403",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "623,439",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "6,635.25",
    "Price vs Market": "4,275.25",
    Available_From: "Feb 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/623439",
  },
  {
    LL_ID: "9e9838cf-faa1-4ecc-8d0a-dc76053342f0",
    ll_name: "PickThePlace",
    RU_ID: "431,109",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "6,800",
    "Price vs Market": "2,690",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/431109",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "608,874",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "6,862.17",
    "Price vs Market": "942.17",
    Available_From: "Feb 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/608874",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "601,914",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "6,862.17",
    "Price vs Market": "2,022.17",
    Available_From: "Feb 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/601914",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "424,934",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "6,993.5",
    "Price vs Market": "",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/424934",
  },
  {
    LL_ID: "cdbcd868-7351-4563-9625-8dadd22e3a76",
    ll_name: "Mark Nelson",
    RU_ID: "363,206",
    Verified: "yes",
    City: "london",
    Neigbourhood: "croydon",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "630",
    "Price vs Market": "30",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/363206",
  },
  {
    LL_ID: "5e3cbf06-821d-45e4-bb2f-a496ec8fc97d",
    ll_name: "ehousing and cleaning",
    RU_ID: "279,040",
    Verified: "yes",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "650",
    "Price vs Market": "-100",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/279040",
  },
  {
    LL_ID: "eef1b5a8-d249-4bb2-af93-2c4055c647a4",
    ll_name: "Patrick Palmer",
    RU_ID: "603,959",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "650",
    "Price vs Market": "-100",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/603959",
  },
  {
    LL_ID: "3bcf7942-e88a-429e-9131-e985e36e1b3c",
    ll_name: "Tuba Bayraktar",
    RU_ID: "140,356",
    Verified: "yes",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "650",
    "Price vs Market": "-100",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/140356",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,991",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "650",
    "Price vs Market": "-50",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609991",
  },
  {
    LL_ID: "beee956f-d80f-48a2-8445-bfe760a8122e",
    ll_name: "Accommodation London",
    RU_ID: "363,513",
    Verified: "no",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "650",
    "Price vs Market": "-50",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/363513",
  },
  {
    LL_ID: "beee956f-d80f-48a2-8445-bfe760a8122e",
    ll_name: "Accommodation London",
    RU_ID: "363,514",
    Verified: "no",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "650",
    "Price vs Market": "-50",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/363514",
  },
  {
    LL_ID: "beee956f-d80f-48a2-8445-bfe760a8122e",
    ll_name: "Accommodation London",
    RU_ID: "451,836",
    Verified: "no",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "650",
    "Price vs Market": "-50",
    Available_From: "Feb 23, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/451836",
  },
  {
    LL_ID: "b5c69f2f-3bab-4ff9-b69a-471a420531a6",
    ll_name: "Christian Igwegbe",
    RU_ID: "313,507",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "650",
    "Price vs Market": "0",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/313507",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "120,120",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "660",
    "Price vs Market": "-550",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/120120",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "120,114",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "660",
    "Price vs Market": "-550",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/120114",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "150,845",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "680",
    "Price vs Market": "-210",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/150845",
  },
  {
    LL_ID: "3bcf7942-e88a-429e-9131-e985e36e1b3c",
    ll_name: "Tuba Bayraktar",
    RU_ID: "156,006",
    Verified: "yes",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "690",
    "Price vs Market": "-60",
    Available_From: "Apr 18, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/156006",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "99,151",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "693",
    "Price vs Market": "-187",
    Available_From: "Mar 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/99151",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "276,524",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "693",
    "Price vs Market": "-17",
    Available_From: "Mar 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/276524",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "143,482",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "693",
    "Price vs Market": "-7",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/143482",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "138,738",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "693",
    "Price vs Market": "-7",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/138738",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "138,740",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "693",
    "Price vs Market": "-7",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/138740",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "99,123",
    Verified: "yes",
    City: "london",
    Neigbourhood: "waltham forest",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "693",
    "Price vs Market": "33",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/99123",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "99,124",
    Verified: "yes",
    City: "london",
    Neigbourhood: "waltham forest",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "693",
    "Price vs Market": "33",
    Available_From: "Feb 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/99124",
  },
  {
    LL_ID: "73abf5e0-3c17-4a17-99ee-42815aa23680",
    ll_name: "Sarah Popelzai",
    RU_ID: "103,771",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "699",
    "Price vs Market": "-301",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/103771",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "639,519",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "7,434.58",
    "Price vs Market": "2,594.58",
    Available_From: "Feb 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639519",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "358,149",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 5,
    Price: "7,615.42",
    "Price vs Market": "1,055.42",
    Available_From: "Mar 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/358149",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "408,389",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "7,694.58",
    "Price vs Market": "4,364.58",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/408389",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "120,118",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "700",
    "Price vs Market": "-510",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/120118",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "150,847",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "700",
    "Price vs Market": "-190",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/150847",
  },
  {
    LL_ID: "5e509b36-496e-438a-9888-2a2f1ad5b1d9",
    ll_name: "Charmaine Grant",
    RU_ID: "569,724",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "700",
    "Price vs Market": "-50",
    Available_From: "Mar 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/569724",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "268,743",
    Verified: "yes",
    City: "london",
    Neigbourhood: "ealing",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "710",
    "Price vs Market": "-80",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/268743",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "99,152",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "715",
    "Price vs Market": "-165",
    Available_From: "Apr 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/99152",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "120,034",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "715",
    "Price vs Market": "-165",
    Available_From: "Mar 18, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/120034",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "124,010",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 9,
    Price: "715",
    "Price vs Market": "-25",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/124010",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "115,901",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 9,
    Price: "715",
    "Price vs Market": "-25",
    Available_From: "Feb 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/115901",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "118,096",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "715",
    "Price vs Market": "-15",
    Available_From: "Apr 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/118096",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "99,121",
    Verified: "yes",
    City: "london",
    Neigbourhood: "waltham forest",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "715",
    "Price vs Market": "55",
    Available_From: "Mar 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/99121",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "118,119",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "715",
    "Price vs Market": "155",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/118119",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "99,150",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "720",
    "Price vs Market": "-160",
    Available_From: "Apr 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/99150",
  },
  {
    LL_ID: "654a4263-34b9-4ac2-8668-42cdbfaf5277",
    ll_name: "Access London",
    RU_ID: "392,070",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "737",
    "Price vs Market": "-163",
    Available_From: "Apr 14, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/392070",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "99,125",
    Verified: "yes",
    City: "london",
    Neigbourhood: "waltham forest",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "737",
    "Price vs Market": "77",
    Available_From: "Apr 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/99125",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "303,919",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "740",
    "Price vs Market": "-10",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/303919",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "303,918",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "740",
    "Price vs Market": "-10",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/303918",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,988",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "740",
    "Price vs Market": "40",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609988",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "137,757",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "-410",
    Available_From: "Apr 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/137757",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "165,089",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "-250",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/165089",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "150,844",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "750",
    "Price vs Market": "-140",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/150844",
  },
  {
    LL_ID: "fe8764f4-1197-4c3f-b407-a0cffedee6e2",
    ll_name: "Cuba Charles",
    RU_ID: "379,385",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lewisham",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "-40",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/379385",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "132,526",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "-30",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132526",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "507,021",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "750",
    "Price vs Market": "100",
    Available_From: "Mar 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/507021",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "508,286",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "760",
    "Price vs Market": "-250",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/508286",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "132,529",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "760",
    "Price vs Market": "-20",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132529",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,969",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "760",
    "Price vs Market": "10",
    Available_From: "Apr 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609969",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "122,777",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "762",
    "Price vs Market": "-438",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/122777",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "117,373",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "762",
    "Price vs Market": "-438",
    Available_From: "Feb 24, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/117373",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "166,149",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "765",
    "Price vs Market": "-435",
    Available_From: "Apr 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/166149",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "507,023",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "770",
    "Price vs Market": "120",
    Available_From: "Apr 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/507023",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "371,179",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "784",
    "Price vs Market": "54",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/371179",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "115,899",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 9,
    Price: "789",
    "Price vs Market": "49",
    Available_From: "Mar 29, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/115899",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "118,025",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 9,
    Price: "789",
    "Price vs Market": "49",
    Available_From: "Apr 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/118025",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "115,900",
    Verified: "yes",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 9,
    Price: "789",
    "Price vs Market": "49",
    Available_From: "Mar 29, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/115900",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "268,745",
    Verified: "yes",
    City: "london",
    Neigbourhood: "ealing",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "790",
    "Price vs Market": "0",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/268745",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "132,533",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "790",
    "Price vs Market": "30",
    Available_From: "Mar 23, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132533",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "354,023",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "8,046.83",
    "Price vs Market": "4,526.83",
    Available_From: "Mar 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/354023",
  },
  {
    LL_ID: "9e9838cf-faa1-4ecc-8d0a-dc76053342f0",
    ll_name: "PickThePlace",
    RU_ID: "431,335",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "8,100",
    "Price vs Market": "4,270",
    Available_From: "Feb 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/431335",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "460,360",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "8,177.58",
    "Price vs Market": "2,937.58",
    Available_From: "Mar 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/460360",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,239",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "8,500",
    "Price vs Market": "3,660",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448239",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,293",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "8,500",
    "Price vs Market": "3,660",
    Available_From: "Feb 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448293",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,262",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "8,500",
    "Price vs Market": "3,660",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448262",
  },
  {
    LL_ID: "d96e65e2-db79-4dc6-adf2-40cf94bca50a",
    ll_name: "Optima Share",
    RU_ID: "327,130",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "800",
    "Price vs Market": "-40",
    Available_From: "Apr 25, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/327130",
  },
  {
    LL_ID: "fe8764f4-1197-4c3f-b407-a0cffedee6e2",
    ll_name: "Cuba Charles",
    RU_ID: "379,386",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lewisham",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "800",
    "Price vs Market": "10",
    Available_From: "Feb 20, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/379386",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "268,905",
    Verified: "yes",
    City: "london",
    Neigbourhood: "ealing",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "800",
    "Price vs Market": "10",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/268905",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,970",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "800",
    "Price vs Market": "50",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609970",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,967",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "800",
    "Price vs Market": "50",
    Available_From: "Mar 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609967",
  },
  {
    LL_ID: "5e509b36-496e-438a-9888-2a2f1ad5b1d9",
    ll_name: "Charmaine Grant",
    RU_ID: "607,131",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "800",
    "Price vs Market": "50",
    Available_From: "Feb 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/607131",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "461,635",
    Verified: "no",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "800",
    "Price vs Market": "70",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/461635",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "461,633",
    Verified: "no",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "800",
    "Price vs Market": "70",
    Available_From: "Apr 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/461633",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "461,632",
    Verified: "no",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "800",
    "Price vs Market": "70",
    Available_From: "Apr 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/461632",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "461,634",
    Verified: "no",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "800",
    "Price vs Market": "70",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/461634",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,989",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "800",
    "Price vs Market": "100",
    Available_From: "Mar 10, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609989",
  },
  {
    LL_ID: "654a4263-34b9-4ac2-8668-42cdbfaf5277",
    ll_name: "Access London",
    RU_ID: "392,072",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "802",
    "Price vs Market": "-98",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/392072",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "132,509",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "808",
    "Price vs Market": "-22",
    Available_From: "Mar 9, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132509",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "318,628",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "810",
    "Price vs Market": "-190",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/318628",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "340,896",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "810",
    "Price vs Market": "30",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/340896",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "210,143",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "823",
    "Price vs Market": "-377",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/210143",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "308,450",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "823",
    "Price vs Market": "43",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/308450",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "508,284",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "825",
    "Price vs Market": "-185",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/508284",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "137,707",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "840",
    "Price vs Market": "-110",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/137707",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "475,255",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "840",
    "Price vs Market": "-90",
    Available_From: "Mar 23, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/475255",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "605,397",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "840",
    "Price vs Market": "-90",
    Available_From: "Feb 11, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605397",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,955",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "850",
    "Price vs Market": "-780",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506955",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "160,427",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "850",
    "Price vs Market": "-350",
    Available_From: "Mar 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/160427",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "210,140",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "850",
    "Price vs Market": "-350",
    Available_From: "Apr 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/210140",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "150,273",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "850",
    "Price vs Market": "-150",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/150273",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,852",
    Verified: "no",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "850",
    "Price vs Market": "0",
    Available_From: "Mar 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506852",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "461,657",
    Verified: "no",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "850",
    "Price vs Market": "120",
    Available_From: "Feb 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/461657",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "143,476",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "850",
    "Price vs Market": "150",
    Available_From: "Apr 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/143476",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "98,969",
    Verified: "yes",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "858",
    "Price vs Market": "298",
    Available_From: "Mar 28, 2022",
    "Admin Fee Type": "notDefined",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/98969",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "152,638",
    Verified: "yes",
    City: "london",
    Neigbourhood: "wandsworth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "860",
    "Price vs Market": "-120",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/152638",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "303,917",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "860",
    "Price vs Market": "110",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/303917",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "132,505",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "870",
    "Price vs Market": "40",
    Available_From: "Mar 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132505",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "132,534",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "870",
    "Price vs Market": "250",
    Available_From: "Mar 5, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132534",
  },
  {
    LL_ID: "2d391945-afce-4510-a1e1-3824bd3e5b86",
    ll_name: "Ash Velmi",
    RU_ID: "413,330",
    Verified: "yes",
    City: "london",
    Neigbourhood: "brent",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "879",
    "Price vs Market": "-171",
    Available_From: "Apr 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/413330",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,956",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "880",
    "Price vs Market": "-750",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506956",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "235,443",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "880",
    "Price vs Market": "-190",
    Available_From: "Mar 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/235443",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "508,283",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "880",
    "Price vs Market": "-130",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/508283",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "233,837",
    Verified: "yes",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "890",
    "Price vs Market": "-180",
    Available_From: "Apr 4, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/233837",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,918",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "890",
    "Price vs Market": "-10",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506918",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "306,163",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "890",
    "Price vs Market": "-10",
    Available_From: "Apr 4, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/306163",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,280",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "9,000",
    "Price vs Market": "4,160",
    Available_From: "Feb 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448280",
  },
  {
    LL_ID: "fa5701e2-6660-4f71-beb0-1faad62b0aa0",
    ll_name: "Maria Kovaleva",
    RU_ID: "448,286",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "9,000",
    "Price vs Market": "4,160",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/448286",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "354,039",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 3,
    Price: "9,293.42",
    "Price vs Market": "2,733.42",
    Available_From: "Mar 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/354039",
  },
  {
    LL_ID: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    RU_ID: "639,556",
    Verified: "no",
    City: "london",
    Neigbourhood: "camden",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 4,
    Price: "9,421.25",
    "Price vs Market": "",
    Available_From: "Apr 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "",
    Link: "http://www.spotahome.com/london/for-rent:apartments/639556",
  },
  {
    LL_ID: "9e9838cf-faa1-4ecc-8d0a-dc76053342f0",
    ll_name: "PickThePlace",
    RU_ID: "431,344",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 2,
    Price: "9,800",
    "Price vs Market": "6,000",
    Available_From: "Mar 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/431344",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,957",
    Verified: "no",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "900",
    "Price vs Market": "-730",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506957",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "517,501",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "900",
    "Price vs Market": "-50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/517501",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "517,500",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "900",
    "Price vs Market": "-50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/517500",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "517,499",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "900",
    "Price vs Market": "-50",
    Available_From: "May 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/517499",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "517,495",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "900",
    "Price vs Market": "-50",
    Available_From: "Apr 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/517495",
  },
  {
    LL_ID: "d96e65e2-db79-4dc6-adf2-40cf94bca50a",
    ll_name: "Optima Share",
    RU_ID: "327,132",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "900",
    "Price vs Market": "60",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/327132",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,966",
    Verified: "no",
    City: "london",
    Neigbourhood: "lambeth",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "900",
    "Price vs Market": "110",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506966",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "340,893",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "906",
    "Price vs Market": "126",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/340893",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "117,087",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "906",
    "Price vs Market": "206",
    Available_From: "Mar 14, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/117087",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "309,946",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "910",
    "Price vs Market": "-300",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/309946",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "166,371",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "910",
    "Price vs Market": "-10",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/166371",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,919",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "910",
    "Price vs Market": "10",
    Available_From: "Apr 17, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506919",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "306,203",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "910",
    "Price vs Market": "20",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/306203",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "609,990",
    Verified: "no",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "910",
    "Price vs Market": "210",
    Available_From: "Feb 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/609990",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "132,520",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "920",
    "Price vs Market": "300",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/132520",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "134,042",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "923",
    "Price vs Market": "63",
    Available_From: "Mar 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/134042",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "307,732",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "923",
    "Price vs Market": "143",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/307732",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "306,175",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "930",
    "Price vs Market": "-700",
    Available_From: "Apr 12, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/306175",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "605,711",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "931",
    "Price vs Market": "-269",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/605711",
  },
  {
    LL_ID: "99a912d1-cca8-4250-ad0d-15cebdfd0181",
    ll_name: "Myrooms",
    RU_ID: "641,433",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "931",
    "Price vs Market": "-69",
    Available_From: "Apr 8, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/641433",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "160,988",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "932",
    "Price vs Market": "-268",
    Available_From: "Apr 23, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/160988",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "115,836",
    Verified: "yes",
    City: "london",
    Neigbourhood: "haringey",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "932",
    "Price vs Market": "232",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/115836",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "475,391",
    Verified: "no",
    City: "london",
    Neigbourhood: "newham",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "940",
    "Price vs Market": "-160",
    Available_From: "Mar 31, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/475391",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "567,355",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "940",
    "Price vs Market": "50",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/567355",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "143,134",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "940",
    "Price vs Market": "130",
    Available_From: "Apr 28, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/143134",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "475,408",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "940",
    "Price vs Market": "150",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/475408",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "117,365",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "950",
    "Price vs Market": "-260",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/117365",
  },
  {
    LL_ID: "d96e65e2-db79-4dc6-adf2-40cf94bca50a",
    ll_name: "Optima Share",
    RU_ID: "327,736",
    Verified: "yes",
    City: "london",
    Neigbourhood: "islington",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "950",
    "Price vs Market": "-130",
    Available_From: "Apr 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/327736",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "306,165",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "950",
    "Price vs Market": "50",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/306165",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "306,162",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "950",
    "Price vs Market": "50",
    Available_From: "Apr 4, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/306162",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "455,561",
    Verified: "no",
    City: "london",
    Neigbourhood: "merton",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "950",
    "Price vs Market": "130",
    Available_From: "Mar 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/455561",
  },
  {
    LL_ID: "6156711c-534d-42e0-8e52-4f926d06173a",
    ll_name: "DMC Management",
    RU_ID: "455,558",
    Verified: "no",
    City: "london",
    Neigbourhood: "merton",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "950",
    "Price vs Market": "130",
    Available_From: "Feb 27, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/455558",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "207,720",
    Verified: "yes",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "953",
    "Price vs Market": "3",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/207720",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "227,105",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hackney",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "970",
    "Price vs Market": "-240",
    Available_From: "Apr 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/227105",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "152,685",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "970",
    "Price vs Market": "-30",
    Available_From: "Apr 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/152685",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "134,644",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "970",
    "Price vs Market": "40",
    Available_From: "Mar 30, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/134644",
  },
  {
    LL_ID: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    RU_ID: "308,449",
    Verified: "yes",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "975",
    "Price vs Market": "195",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/308449",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "506,890",
    Verified: "no",
    City: "london",
    Neigbourhood: "westminster",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "980",
    "Price vs Market": "-20",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/506890",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "218,002",
    Verified: "yes",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "980",
    "Price vs Market": "60",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/218002",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "306,164",
    Verified: "no",
    City: "london",
    Neigbourhood: "hammersmith and fulham",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "985",
    "Price vs Market": "85",
    Available_From: "Apr 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/306164",
  },
  {
    LL_ID: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "City Accommodations",
    RU_ID: "152,686",
    Verified: "yes",
    City: "london",
    Neigbourhood: "kensington and chelsea",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "990",
    "Price vs Market": "-10",
    Available_From: "May 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/152686",
  },
  {
    LL_ID: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "5d Property Ltd",
    RU_ID: "475,410",
    Verified: "no",
    City: "london",
    Neigbourhood: "tower hamlets",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "990",
    "Price vs Market": "200",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/london/for-rent:apartments/475410",
  },
];
